import { render } from "./LevelUp.vue?vue&type=template&id=4686b094&scoped=true"
import script from "./LevelUp.vue?vue&type=script&lang=js"
export * from "./LevelUp.vue?vue&type=script&lang=js"

import "./LevelUp.vue?vue&type=style&index=0&id=4686b094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4686b094"]])

export default __exports__